import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { EmailViewModel } from '../../../models/Entities/Person/Email/EmailModels';

// store
import * as PersonEmailsStore from '../../../redux/middleware/PersonEmails.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  PersonId: number;
  emailId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  email?: EmailViewModel;
}

interface DispatchProps {
  CreateEmail: typeof PersonEmailsStore.actionCreators.CreateEmail;
  UpdateEmail: typeof PersonEmailsStore.actionCreators.UpdateEmail;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonEmails?.isAddingNewOne,
  successAdding: state.PersonEmails?.successAddingNewOne,
  failAdding: state.PersonEmails?.failOnAddingNewOne,
  isUpdating: state.PersonEmails?.isUpdatingOne,
  successUpdating: state.PersonEmails?.successUpdatingOne,
  failUpdating: state.PersonEmails?.failOnUpdatingOne,
  error: state.PersonEmails?.error,
  email: state.PersonEmails?.list.find((item: EmailViewModel) => item.id === ownProps.emailId),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonEmailsStore.actionCreators
};
